import React from 'react';
import { RangeInputContainer } from '../GenerateOffer.styles';

const CustomRangeInput = React.forwardRef(
  ({ start, end, onClick, placeholderStart, placeholderEnd, className }, ref) => {
    const pad = n => String(n).padStart(2, '0');
    const formatDate = (d) => {
      if (!d) return '';
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    };
    return (
      <RangeInputContainer className={className} ref={ref} onClick={onClick} data-cy="offer-date-range">
        <input type="text" readOnly value={formatDate(start)} placeholder={placeholderStart} data-cy="offer-date-from" />
        <span className="range-sep">→</span>
        <input type="text" readOnly value={formatDate(end)} placeholder={placeholderEnd} data-cy="offer-date-to" />
      </RangeInputContainer>
    );
  }
);

export default CustomRangeInput;
